import { ILicenseActivation, LicenseActivation } from "./LicenseActivation";

export class LicenseActivationBill {
    constructor(licenseActivationBill?: ILicenseActivationBill) {
        this.activations = [];
        if (licenseActivationBill != null) {
            this.customerNumber = licenseActivationBill.customerNumber;
            this.customerName = licenseActivationBill.customerName;
            this.campusProfileId = licenseActivationBill.campusProfileId;
            this.campusName = licenseActivationBill.campusName;
            this.beginDate = licenseActivationBill.beginDate;
            this.endDate = licenseActivationBill.endDate;
            if (licenseActivationBill.activations)
                this.activations = licenseActivationBill.activations.map((a) => new LicenseActivation(a));
            if (!licenseActivationBill.activations)
                this._activationCount = licenseActivationBill.activationCount;
        }
    }

    customerNumber: string;
    customerName: string;
    campusProfileId: string;
    campusName: string;
    beginDate?: string;
    endDate?: string;

    activations: LicenseActivation[]

    private _activationCount;
    get activationCount(): number {
        return this._activationCount ?? this.activations.length;
    }
    set activationCount(value: number) {
        this._activationCount = value;
    }

    get customerNameAndCampus() {
        return this.customerName + (this.campusName != null && this.campusName != this.customerName ? ` (${this.campusName})` : "");
    }
}

export interface ILicenseActivationBill {
    customerNumber: string;
    customerName: string;
    campusProfileId: string;
    campusName: string;
    beginDate?: string;
    endDate?: string;
    activations?: ILicenseActivation[];
    activationCount: number;
}